'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderCoamMentionSuggestion = function renderCoamMentionSuggestion(entry, search, highlightedDisplay, index) {
    return _react2.default.createElement(
        'span',
        null,
        highlightedDisplay,
        ' ',
        _react2.default.createElement(
            'i',
            null,
            _react2.default.createElement(
                'small',
                null,
                entry.email
            )
        )
    );
};

exports.default = renderCoamMentionSuggestion;